// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* *{
    margin: 0;
    padding: 0;
} */

.CourseRegistrationTable{
    margin: 70px 10px ;
    background-color: aqua;
    /* border: 1px solid gray; */
    border-collapse: collapse;
}

.CourseRegistrationTable-th,.CourseRegistrationTable-tr,.CourseRegistrationTable-td{
    /* border: 1px solid gray; */
    max-width: 20%;
    text-align: center;
    /* padding:0 2% 0 2%/; */
}

.CourseRegistrationTable-th{
    color: rgb(255, 255, 255);
    padding: 10px;
    background-color: rgb(135, 138, 150);
}

.CourseRegistrationRadioType{
    text-align: start;
    padding-left: 5px;
    font-size: 14px;    
}

.CourseRegistrationSelect,.CourseRegistrationOption{
    max-width: 100%;
    min-width: 30%;
    min-height:2vh;
    
}

.CourseRegistrationTable-td{
    background-color: rgb(200, 223, 250);
}

.CourseRegistrationButton{
    background: none rgb(0, 158, 176);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 15px;
    font-weight: bold;
    padding: 8px;
    cursor: pointer;
}

.type-section{
    display: flex;
    align-items: center;
}

.CourseRegistrationInput{
    cursor: pointer;
}

.CourseRegistrationLabel{
    padding-left: 3px;
}


.CourseRegistrationButton.disabled {
    background-color: rgba(0, 0, 0, 0.1); /* Add a background blur effect */
}

.CourseRegistrationButton.disabled:hover {
    cursor: not-allowed; /* Change cursor to not-allowed when button is disabled */
}

.CourseRegistrationButton.disabled:hover svg {
    color: red; /* Change color of the cross icon when button is hovered */
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/AdminActions/CourseRegistration.css"],"names":[],"mappings":"AAAA;;;GAGG;;AAEH;IACI,kBAAkB;IAClB,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,oCAAoC,EAAE,iCAAiC;AAC3E;;AAEA;IACI,mBAAmB,EAAE,yDAAyD;AAClF;;AAEA;IACI,UAAU,EAAE,0DAA0D;AAC1E","sourcesContent":["/* *{\n    margin: 0;\n    padding: 0;\n} */\n\n.CourseRegistrationTable{\n    margin: 70px 10px ;\n    background-color: aqua;\n    /* border: 1px solid gray; */\n    border-collapse: collapse;\n}\n\n.CourseRegistrationTable-th,.CourseRegistrationTable-tr,.CourseRegistrationTable-td{\n    /* border: 1px solid gray; */\n    max-width: 20%;\n    text-align: center;\n    /* padding:0 2% 0 2%/; */\n}\n\n.CourseRegistrationTable-th{\n    color: rgb(255, 255, 255);\n    padding: 10px;\n    background-color: rgb(135, 138, 150);\n}\n\n.CourseRegistrationRadioType{\n    text-align: start;\n    padding-left: 5px;\n    font-size: 14px;    \n}\n\n.CourseRegistrationSelect,.CourseRegistrationOption{\n    max-width: 100%;\n    min-width: 30%;\n    min-height:2vh;\n    \n}\n\n.CourseRegistrationTable-td{\n    background-color: rgb(200, 223, 250);\n}\n\n.CourseRegistrationButton{\n    background: none rgb(0, 158, 176);\n    color: white;\n    border: none;\n    border-radius: 8px;\n    font-size: 15px;\n    font-weight: bold;\n    padding: 8px;\n    cursor: pointer;\n}\n\n.type-section{\n    display: flex;\n    align-items: center;\n}\n\n.CourseRegistrationInput{\n    cursor: pointer;\n}\n\n.CourseRegistrationLabel{\n    padding-left: 3px;\n}\n\n\n.CourseRegistrationButton.disabled {\n    background-color: rgba(0, 0, 0, 0.1); /* Add a background blur effect */\n}\n\n.CourseRegistrationButton.disabled:hover {\n    cursor: not-allowed; /* Change cursor to not-allowed when button is disabled */\n}\n\n.CourseRegistrationButton.disabled:hover svg {\n    color: red; /* Change color of the cross icon when button is hovered */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
